// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4e22e6ff","845":"2ff7a58f"}[chunkId] + ".chunk.js";
};